import React from 'react';
import styles from "./styles.module.css";
import clsx from 'clsx';
import EntryCounterImage from '../../assets/open-door-icon.svg';
import { useTranslation } from 'react-i18next';
interface EntryCounterProps {
  EntriesLeft : string
}
const EntryCounter : React.FC<EntryCounterProps> = (
  {EntriesLeft}
) => {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles.entryCounter,"fontWeightBold fontSizeSm14")}>
    <img
      loading="lazy"
      src={EntryCounterImage}
      className={styles.counterIcon}
      alt=""
    />
    <div className={styles.counterText}>{EntriesLeft}</div>
  </div>
  )
}
export default EntryCounter